import { connect } from 'react-redux';
import LaneInfo from '../components/lane-info';

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(LaneInfo);
